(function(){
  $(document).ready(function() {
    $("#shopify-section-NB-megamenu-container").remove();
    flexFont();
    setPercent();
    setHeight();
    $('#nav-icon').click(function(){
      toggleNav();
    });
    // smooth scroll code
    $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 80
          }, 1000, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { 
              return false;
            } else {
              $target.attr('tabindex','-1'); 
              $target.focus(); 
            };
          });
        }
      }
    });
    // q&a collapsibles
    var coll = document.getElementsByClassName('qa--dropdowns-collapsible');
    for (let i in coll) {
      coll[i].addEventListener('click', function() {
        this.classList.toggle('active');
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
          content.style.padding = '0 18px';
        } else {
          content.style.maxHeight = (content.scrollHeight + 36) + 'px';
          content.style.padding = '18px';
        } 
      });
    }
  });
  //set background color and drop shadow for header on page scroll
  $(document).scroll(function () {
    var $nav = $('.hero--site-header');
    $nav.toggleClass('moving', $(this).scrollTop() > $nav.height());
  });
})();
flexFont = function () {
  var divs = document.getElementsByClassName('flexFont');
  for(var i = 0; i < divs.length; i++) {
    var relFontsize = divs[i].offsetWidth*0.05;
    divs[i].style.fontSize = relFontsize+'px';
  }
};
setPercent = function () {
  var main = document.getElementById('main-body');
  if (main.offsetWidth >= 1600) {
    relFontSize = Math.round((main.offsetWidth / 1920) * 100);
    main.style.fontSize = relFontSize + '%';
  }
}
setHeight = function () {
  var img = document.querySelector('.top--top-right img');
  img.style.height = img.offsetWidth * .55 + 'px';
}
toggleNav = function () {
  var navBar = $('.hero--site-header');
  if(!navBar.hasClass('moving')){
    navBar.toggleClass('moving');
  }
  var navIcon = $('#nav-icon');
  navIcon.toggleClass('open');
  $('#nav-content').slideToggle(function() {
  });
}
handleATC = function () {
  var kitID = window.location.host.includes('staging') ? 20006110527546 : 12118268739628;
  var product = {
    id: kitID,
    quantity: 1
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: product,
    success: function (data) {
      if (data != null) {
        moveAlong();
      }
    }
  });
  moveAlong = function() {
    var cartCount = document.getElementById('cart-count').value;
    if (document.referrer == '' || document.referrer.includes('northernbrewer') || cartCount > 0) {
      document.location.replace('/cart');
    } else {
      document.location.replace('/checkout');
    }
  }
}
window.onresize = function(event) {
  flexFont();
  setPercent();
  setHeight();
};
